/* src/app/auth/sign-in/sign-in.component.scss */
.sign-in {
  display: flex;
  height: 100px;
  justify-content: space-between;
  flex-direction: column;
}
.sign-in > div > label {
  padding: 1rem;
  width: 95px;
}
.menuItem {
  max-width: 500px;
  background-color: whitesmoke;
  color: red;
}
/*# sourceMappingURL=sign-in.component.css.map */
